const PointToChangeColumns = 1000;
export function useShouldUseMobileColumns(): boolean {
  return document.documentElement.clientWidth < PointToChangeColumns;
}
